export default class BaseModel {
  public static extend<T>(target: T, source: any): T {
    if (source) {
      for (const prop in source) {
        if (source.hasOwnProperty(prop)) {
          target[prop] = source[prop];
        }
      }
    }
    return target;
  }

  public static cast<T>(json: any, base: any): T {
    if (Array.isArray(json)) {
      throw new Error('Expecting an Object');
    } else {
      const castResult = this.extend(new base(), json);
      return castResult;
    }
  }

  public static castArray<T>(json: any, base: any): T[] {
    if (Array.isArray(json)) {
      return json.map((obj: any) => {
        return this.cast(obj, base);
      });
    } else {
      throw new Error('Expecting an Array');
    }
  }
}
